import React, { useState, useRef, useEffect } from "react";
import styles from "../Home/Home.module.css";
import "./Profile.css";
import videoCardStyles from "./videocard.module.css";
import { FaEllipsisV } from "react-icons/fa";
import config from "../../config/api.config";

const VideoCard = ({ video, index, user, handleVideoClick, privacy }) => {
  console.log("privacy", privacy === "public");
  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleEllipsisClick = (e) => {
    e.stopPropagation(); // Prevent video click event
    setShowDropdown(!showDropdown);
  };

  const handlePrivacyChange = async (e, newPrivacy) => {
    e.stopPropagation();
    try {
      // show like youwant to change privacy
      if (window.confirm("Are you sure you want to change privacy?")) {
        console.log("newPrivacy====", newPrivacy);
        const response = await fetch(
          `/api/updatevisibility/updateVideoStatus`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },

            body: JSON.stringify({
              visibility: newPrivacy,
              videoId: video.videoId,
              userId: user._id,
            }),
          }
        );

        if (response.ok) {
          setShowDropdown(false);
          window.location.reload();
        }
      }
    } catch (error) {
      console.error("Error updating privacy:", error);
    }
  };

  const handleDelete = async (e) => {
    e.stopPropagation();
    if (window.confirm("Are you sure you want to delete this video?")) {
      try {
        const response = await fetch(`/api/updatevisibility/deleteVideo`, {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
          body: JSON.stringify({ videoId: video.videoId }),
        });

        if (response.status === 200) {
          // You might want to add a callback prop to refresh the video list
          setShowDropdown(false);
          window.location.reload();
        }
      } catch (error) {
        console.error("Error deleting video:", error);
        alert("Error deleting video");
      }
    }
  };

  return (
    <div
      key={video.videoId + index + Math.random()}
      className={styles.videoCard}
    >
      <img
        onClick={() => handleVideoClick(video)}
        src={`${config.ThumbUrl}/videos/${video.videoId}/thumbnail.jpg`}
        alt={video.title}
        className={styles.thumbnail}
      />
      <div className={styles.videoInfo}>
        <h3>{video.title}</h3>
        <p className={videoCardStyles.videoStats}>
          <div className={videoCardStyles.dropdownContainer} ref={dropdownRef}>
            <button
              onClick={handleEllipsisClick}
              className={videoCardStyles.ellipsis}
            >
              <FaEllipsisV />
            </button>
            {showDropdown && (
              <div className={videoCardStyles.dropdown}>
                <button
                  onClick={(e) => handlePrivacyChange(e, "public")}
                  disabled={privacy === "public"}
                  className={
                    privacy === "public" ? videoCardStyles.disabled : ""
                  }
                >
                  Make Public
                </button>
                <button
                  onClick={(e) => handlePrivacyChange(e, "private")}
                  disabled={privacy === "private"}
                  className={
                    privacy === "private" ? videoCardStyles.disabled : ""
                  }
                >
                  Make Private
                </button>
                <button
                  onClick={handleDelete}
                  className={videoCardStyles.delete}
                >
                  Delete
                </button>
              </div>
            )}
          </div>
          {/* {" Created At: " + new Date(video.createdAt).toLocaleDateString()} */}
          {(() => {
            const createdDate = new Date(video.createdAt);
            const now = new Date();
            const diffMs = now - createdDate;
            const diffHrs = Math.floor(diffMs / (1000 * 60 * 60));
            const diffMins = Math.floor(
              (diffMs % (1000 * 60 * 60)) / (1000 * 60)
            );

            if (createdDate.toLocaleDateString() === now.toLocaleDateString()) {
              return diffHrs > 0
                ? `${diffHrs} hours ${diffMins} minutes ago`
                : `${diffMins} minutes ago`;
            }
            return createdDate.toLocaleDateString();
          })()}
        </p>
      </div>
    </div>
  );
};

export default VideoCard;
